// extracted by mini-css-extract-plugin
export default {"jpRunning":"JP_Footer_jpRunning__KiC-d","jpCurrentDate":"JP_Footer_jpCurrentDate__0jbce","jpFootage":"JP_Footer_jpFootage__9bqu+","higlight":"JP_Footer_higlight__Gj4r8"};